import React from "react";
import LightTheme from "../theme/LightTheme";

interface Props {
  children: React.ReactNode;
  onClick: () => void;
  border?: boolean;
}

const PlainButton = ({ children, onClick, border = true }: Props) => (
  <button className={`${border && "border"}`} onClick={onClick} type="button">
    {children}
    <style jsx>{`
      button {
        padding: 20px;
        border-radius: 6px;
        border: none;
        height: 36px;
        font-weight: 600;
        font-size: 1rem;
        color: ${LightTheme.font.secondary.color};
        background: transparent;
        text-decoration: underline;
        cursor: pointer;
        display: flex;
        align-items: center;
        justify-content: center;
      }
      button:hover {
        color: rgba(143, 35, 152, 1);
      }
      button:active {
        text-decoration-line: none;
        background: ${LightTheme.font.secondary.color};
        color: white;
      }
      .border {
        box-shadow: inset 0 0 0 2px ${LightTheme.font.secondary.color};
      }
    `}</style>
  </button>
);

export default PlainButton;
